import React from 'react';
import tgpsLogo from '../styles/tgps.png';

const BlogsIcon = ({ style, ...props }) => (
  <img
    src={tgpsLogo}
    alt="Blogs Icon"
    style={{
      width: 56,
      height: 56,
      borderRadius: 12,
      boxShadow: '0 2px 8px #0002',
      background: '#fff',
      ...style
    }}
    {...props}
  />
);

export default BlogsIcon;